<template>
  <v-input v-model="value"
           :rules="rules"
           :hide-details="hideDetails"
           class="file-input">
    <v-container fluid
                 :class="['file-input-container', {'dragover': dragover}]"
                 @click="$refs.fileInput.click()"
                 @drop.prevent="onDrop($event)"
                 @dragover.prevent="dragover = true"
                 @dragenter.prevent="dragover = true"
                 @dragleave.prevent="dragover = false">
      <v-icon x-large>mdi-inbox-arrow-down</v-icon>
      <div class="mt-4">{{ dragover ? $t('file_input.dragover_descriptions') : $t('file_input.descriptions') }}</div>
    </v-container>
    <div class="file-input-value"
         v-if="value">
      {{ value.name }}
      <v-icon @click="$emit('input', null)">mdi-delete-outline</v-icon>
    </div>

    <input type="file"
           :accept="accept"
           hidden
           ref="fileInput"
           @change="onFileInputChange">
  </v-input>
</template>

<script>
import {ref} from "@vue/composition-api";

export default {
  name: 'FileInput',
  props: {
    value: File,
    rules: Array,
    hideDetails: String,
    accept: String,
  },
  setup(props, {root, emit}) {
    const fileInput = ref();
    const dragover = ref(false);
    const onDrop = function (e) {
      dragover.value = false;

      let file = e.dataTransfer.files[0];
      if (file) {
        if (!props.accept || file.type === props.accept) {
          emit('input', file);
        } else {
          alert('Invalid File Type');
        }
      }
    }
    const onFileInputChange = async function (e) {
      const file = e.target.files[0];
      fileInput.value.value = '';
      if (file) {
        emit('input', file);
      }
    };

    return {
      fileInput,
      dragover,
      onDrop,
      onFileInputChange,
    }
  },
}
</script>

<style lang="less">
.file-input {
  .v-input__slot {
    display: flex;
    flex-direction: column;
    align-items: baseline;
  }

  .file-input-container {
    border: solid 1px #ADB5BD;
    background-color: #F8F9FA;
    border-radius: 5px;
    flex-direction: column;
    text-align: center;
    user-select: none;

    &:hover {
      cursor: pointer !important;
    }

    &.dragover {
      background-color: #949596;
    }
  }

  .file-input-value {
    font-size: 80%;
  }
}
</style>
